<div class="soft-card">
  <form [formGroup]="form">
    <div class="">
      <label class="soft-label top">{{
        '#APPLICATION.APPEARANCE.THEME' | translate
      }}</label>
      <soft-select formControlName="theme" (valueChange)="set()">
        @for (theme of themes; track theme) {
          <soft-select-option [value]="theme.key ?? null">{{
            theme.name | translate
          }}</soft-select-option>
        }
      </soft-select>
    </div>
    <div class="mt-4">
      <label class="soft-label top">{{
        '#APPLICATION.APPEARANCE.FONT_SIZE' | translate
      }}</label>
      <soft-select formControlName="fontSize" (valueChange)="set()">
        @for (fontSize of fontSizes; track fontSize) {
          <soft-select-option [value]="fontSize.key ?? null">{{
            fontSize.name | translate
          }}</soft-select-option>
        }
      </soft-select>
    </div>
  </form>
</div>
